<template>
  <div class="img-box" :id="boxId" :style="'width:' + nWidth + ';height:' + nHeight" @mousemove="mousemoveFn" @mouseover="mouseoverFn">
    <img :src="src" :id="imgId" alt="">
  </div>
</template>
<script>
export default {
  name: 'ImageShow',
  props: {
    src: '',
    width: '',
    height: '',
    ani: ''
  },
  data () {
    return {
      nWidth: this.width || '300px',
      nHeight: this.height || '200px',
      nAni: this.ani !== undefined,
      scrollHeight: false,
      imgId: 'img' + this.$util.uuid(),
      boxId: 'box' + this.$util.uuid(),
      imgW: '',
      imgH: '',
      imgSw: '',
      imgSh: '',
      imgPosL: '',
      imgPosT: '',
      startX: '',
      startY: ''
    }
  },
  methods: {
    offset (elem) {
      var obj = {
        left: elem.offsetLeft,
        top: elem.offsetTop,
        width: elem.offsetWidth,
        height: elem.offsetHeight
      }
      while (elem !== document.body) {
        elem = elem.offsetParent
        obj.left += elem.offsetLeft
        obj.top += elem.offsetTop
      }
      return obj
    },
    mouseoverFn (ev) {
      if (this.nAni) {
        this.startX = ev.clientX
        this.startY = ev.clientY
      }
    },
    mousemoveFn (ev) {
      if (this.nAni) {
        var boxObj = document.querySelector('#' + this.boxId)
        var imgObj = document.querySelector('#' + this.imgId)
        if (this.scrollHeight) {
          let overflowH = this.imgSh - this.offset(boxObj).height
          let moveY = ev.clientY - this.startY
          let movePercent = moveY / this.offset(boxObj).height * 2
          if ((parseInt(imgObj.style.marginTop) >= -(this.imgSh - (this.offset(boxObj).height / 2)) && moveY < 0) || (parseInt(imgObj.style.marginTop) <= -this.offset(boxObj).height / 2 && moveY > 0)) {
            let newMargin = parseInt(imgObj.style.marginTop) + Math.floor(overflowH * movePercent)
            if (newMargin < -(this.imgSh - (this.offset(boxObj).height / 2))) { newMargin = -(this.imgSh - (this.offset(boxObj).height / 2)) }
            if (newMargin > -this.offset(boxObj).height / 2) { newMargin = -this.offset(boxObj).height / 2 }
            imgObj.style.marginTop = newMargin + 'px'
          }
        } else {
          let overflowW = this.imgSw - this.offset(boxObj).width
          let moveX = ev.clientX - this.startX
          let movePercent = moveX / this.offset(boxObj).width * 2
          if ((parseInt(imgObj.style.marginLeft) >= -(this.imgSw - (this.offset(boxObj).width / 2)) && moveX < 0) || (parseInt(imgObj.style.marginLeft) <= -this.offset(boxObj).width / 2 && moveX > 0)) {
            let newMargin = parseInt(imgObj.style.marginLeft) + Math.floor(overflowW * movePercent)
            if (newMargin < -(this.imgSw - (this.offset(boxObj).width / 2))) { newMargin = -(this.imgSw - (this.offset(boxObj).width / 2)) }
            if (newMargin > -this.offset(boxObj).width / 2) { newMargin = -this.offset(boxObj).width / 2 }
            imgObj.style.marginLeft = newMargin + 'px'
          }
        }
        this.startX = ev.clientX
        this.startY = ev.clientY
      }
    },
    positionFn (obj, type) {
      if (type === 'width') {
        obj.style.maxWidth = '100%'
        this.scrollHeight = true
        this.imgSw = Math.floor(obj.width)
        this.imgSh = Math.floor(obj.height)
        obj.style.top = '50%'
        obj.style.height = Math.floor(this.imgSh) + 'px'
        obj.style.marginTop = -Math.floor(this.imgSh / 2) + 'px'
      } else {
        obj.style.maxHeight = '100%'
        this.scrollHeight = false
        this.imgSw = Math.floor(obj.width)
        this.imgSh = Math.floor(obj.height)
        obj.style.left = '50%'
        obj.style.width = Math.floor(this.imgSw) + 'px'
        obj.style.marginLeft = -Math.floor(this.imgSw / 2) + 'px'
      }
    }
  },
  created () {
    // console.log(this.imgId)
  },
  mounted () {
    var obj = document.querySelector('#' + this.imgId)
    var boxObj = document.querySelector('#' + this.boxId)
    obj.onload = () => {
      this.imgW = obj.width
      this.imgH = obj.height
      var scal1 = parseFloat(boxObj.offsetWidth) / parseFloat(boxObj.offsetHeight)
      var scal2 = this.imgW / this.imgH
      if (scal1 > scal2) {
        this.positionFn(obj, 'width')
      } else {
        this.positionFn(obj, 'height')
      }
    }
  }
}
</script>
<style>
.img-box {
  width: 300px;
  height: 200px;
  position: relative;
  overflow: hidden;
}
.img-box img {
  position: absolute;
  left: 0;
  top: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/common/default/ImageShow.vue